export default "__VITE_ASSET__nF8fP3M$71Mt_SWg$jM6MA__"